module.exports = __webpack_public_path__ + "static/media/pietro-perugino.e06e1a15.jpg";